<template>
  <!-- {{profile}} -->
  <div class="user-wrapper w-100">
    <profile-header></profile-header>
    <div class="user-content">
      <div class="container">
        <!-- <div class="my-auto" style="margin:auto;">
          <div class="row">
            <div class="col-md-12" v-if="show_msg && maintenance_msg != ''">
              <div
                class="msg-area-profile main-area  w-100 "
                style="white-space: pre-line"
              >
                {{ maintenance_msg }}
              </div>
            </div>
          </div>
        </div> -->

        <Loader v-if="Object.keys(profile).length === 0" />

        <!-- <ScoutProfile /> -->

        <Event/>
        
        <!-- RSS Feed Section -->
        <RssFeed />
        
        <!-- ends main-area -->
        <Loader v-if="!data.companies" :field="'companies'" />
        <div class="my-auto w-100 main-area main-area-sharing" v-else>
          <div class="profile-detail">
            <TitleContainer :title="'キャリア登録先企業一覧'">
              <template #button>
                <div class="btn-container">
                  <EditButton
                    title="編集"
                    @click="toggleEdit('sharing')"
                  />
                </div>
              </template>
            </TitleContainer>

            <div class="profile-info-block d-flex flex-column align-items-end" style="border-bottom: 0px">
                <div class="profile-info">
                  <form data-vv-scope="sharing">
                      <table class="table">
                        <tbody>
                          <tr>
                            <td>
                              <span class="edit-txt">
                                <div class="col-lg-12 mb-30" style="padding: 0px;">
                                  <div id="profile-accordion-outer" class="row">
                                    <div
                                      class="col-lg-6 col-md-6 companies"
                                      v-for="(company, index) in data.companies"
                                      v-bind:key="company._id"
                                    >
                                      <div
                                      >
                                        <div class="form-check">
                                          <input
                                          type="checkbox"
                                          :id="company._id"
                                          :value="company._id"
                                          class="form-check-input custom-checkbox"
                                          name="other_companies"
                                          v-model="profile.other_companies"
                                          disabled
                                        />
                                        <label
                                          data-bs-toggle="collapse"
                                          :data-bs-target="'#accordion-' + index"
                                          class="m-1 form-check-label"
                                          :class="{ 'selected-company': profile.other_companies.includes(company._id) }"
                                          style="cursor: pointer; margin-left: 8px !important;"
                                        >
                                          {{ company.name }}
                                          <i
                                            class="fa fa-sort-down"
                                            aria-hidden="true"
                                            style="position: relative; top: -3px"
                                          ></i>
                                        </label>
                                        </div>
                                        <b-collapse
                                          v-bind:id="'accordion-' + index"
                                          accordion="profile-accordion-outer"
                                          role="tabpanel"
                                        >
                                          <b-card
                                            ><span
                                              v-html="
                                                urlify(company.short_description)
                                              "
                                            ></span
                                          ></b-card>
                                        </b-collapse>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </span>
                              <b-modal
                                size="xl"
                                ref="profileSharingModal"
                                @shown="addEventListeners"
                                @hide="removeEventListeners"
                                :no-close-on-esc="true"
                                :no-close-on-backdrop="true"
                              >
                                <template #modal-header>
                                  <!-- Emulate built in modal header close button action -->
                                  <!-- <button type="button" class="close" aria-label="Close" v-on:click.prevent="cancel('sharing')">
                                        <span aria-hidden="true">&times;</span>
                                      </button> -->
                                  <!-- <img
                                    src="../assets/close.png"
                                    v-on:click.prevent="cancel('sharing')"
                                    style="cursor:pointer;margin-top:5px"
                                  /> -->
                                  <h5 class="sharingTitle">
                                    登録先企業の選択・解除
                                  </h5>
                                  <!-- <button
                                    data-v-bf1681ae=""
                                    title="保存"
                                    class="btn btn-secondary rounded btn-sm font-16 editBtn share"
                                    @click="openConfirmModal"
                                  >
                                    保存
                                  </button> -->
                                </template>
                                <div
                                  class="select_all d-flex justify-content-center align-items-center"
                                >
                                  <input
                                    class="custom-checkbox me-3"
                                    type="checkbox"
                                    v-model="selectAllCompaniesModel"
                                    id="select_all"
                                    name="select_all"
                                  />
                                  <label
                                    class="form-check-label font-18"
                                    for="select_all"
                                    style="padding-top: 3px"
                                  >
                                    すべて選択（全{{ data.companies.length }}社）
                                  </label>
                                </div>
                                <div
                                  class="d-flex px-3 py-2 flex-wrap align-items-start companies-container"
                                  style="overflow-y:scroll;max-height:600px"
                                >
                                  <div id="profile-accordion-modal" class="row px-3 py-2">
                                    <div
                                      class="col-lg-6 col-md-6 py-1"
                                      v-for="(company, index) in data.companies"
                                      v-bind:key="company._id"
                                    >
                                      <div
                                        class="d-flex justify-content-between font-16"
                                      >
                                        <div class="d-flex align-items-center">
                                          <div
                                            style="height: 20px; width: 20px;"
                                            class="me-3"
                                          >
                                            <input
                                              class="custom-checkbox"
                                              type="checkbox"
                                              :id="company._id"
                                              :value="company._id"
                                              name="other_companies"
                                              v-model="profile.other_companies"
                                            />
                                          </div>
                                          <label
                                            class="form-check-label "
                                            :for="company._id"
                                            style="padding-top: 3px;"
                                            data-bs-toggle="collapse"
                                            :data-bs-target="`#accordino0_${index}`"
                                          >
                                            {{ company.name }}
                                            <i
                                              class="fa fa-sort-down"
                                              aria-hidden="true"
                                              style="position: relative; top: -3px"
                                            ></i>
                                          </label>
                                        </div>
                                        <div></div>
                                      </div>
                                      <div>
                                        <b-collapse
                                          class="py-1"
                                          v-bind:id="`accordino0_${index}`"
                                          accordion="profile-accordion-modal"
                                          role="tabpanel"
                                        >
                                          <b-card>
                                            <span
                                              style="color: black !important"
                                              v-html="
                                                urlify(company.short_description)
                                              "
                                            >
                                            </span>
                                          </b-card>
                                        </b-collapse>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <template #modal-footer>
                                  <div class="button-container d-flex flex-column align-items-center">
                                      <button class="btn btn-secondary btn-green rounded" @click.prevent="openConfirmModal"">
                                        この内容で保存する
                                      </button>
                                      <CancelModal 
                                        @click="cancel" 
                                      />
                                  </div>
                                </template>
                              </b-modal>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                  </form>
                 </div>
            </div>
            <!-- ends profile-info-block -->
          </div>
          <!-- ends profile-detail -->
        </div>

        <!-- ends main-area -->
      </div>
    </div>
    <!-- ends user-content -->

    <!-- event modal -->

    <ConfirmationModal 
        :show="showSharingConfirm" 
        @cancel="hideConfirm" 
        @confirm="saveSharing"
      >
        <template #content>
          <p class="notice-header-text">
            ご自身の在籍企業など、情報を公開したくない<br/>企業が含まれていないか十分注意してください。
          </p>
          <ul class="notice-list">
            <li>企業を選択した場合、現在ご登録のプロフィール情報が、企業へ公開されます。</li>
            <li>登録企業は、ユーザーが他に登録している企業を確認することはできません。</li>
            <li>ユーザーの承諾無しに、登録企業以外へ情報が公開されることはありません。</li>
          </ul>
      </template>
      <template #confirm-text>
        注意事項に同意して<br />
        <span class="font-bold font-14" style="font-size: 18px">
          登録企業を更新する
        </span>
      </template>
      <template #confirm-text-mobile>
        <span style="font-size:8px">注意事項に同意して</span><br/>
        <span style="font-weight: bold;">登録企業を更新する</span>
      </template>
    </ConfirmationModal>
    <!-- Modal Component -->
    <Footer />
  </div>
  <!-- ends user-wrapper -->
</template>
<script>
/* eslint-disable */
import ProfileHeader from "@/components/header.vue";
import Api from "@/config/api";
// eslint-disable-next-line
import moment from "moment";
import { mapActions, mapGetters } from "vuex";
import swal from "sweetalert";
import Footer from "./Footer.vue";
import logo from "../assets/Group300.png";
import Loader from "./Loader.vue";
import TitleContainer from "./TitleContainer.vue";
import Event from "./Event.vue";
import RssFeed from "./RssFeed.vue";
import ConfirmationModal from "./CompaniesConfirmation.vue"
import CancelModal from "./CancelModal.vue";
import ScoutProfile from "./ScoutProfile/ScoutProfile.vue";
import EditButton from "./EditButton.vue";
import modalEventListener from "../mixins/modalEventListener";
export default {
  components: {
    ProfileHeader,
    Footer,
    Loader,
    TitleContainer,
    Event,
    RssFeed,
    ConfirmationModal,
    CancelModal,
    ScoutProfile,
    EditButton
  },
  mixins: [modalEventListener],
  data() {
    return {
      data: {},
      events: [],
      isEvents: false,
      event: {},
      server_errors: {},
      selectedCursor: "pointer",
      tempSharingData: {},
      maintenance_msg: "",
      show_msg: false,
      selectAllCompaniesModel: false,
      isSharingEdit: true,
      showSharingConfirm: false,
    };
  },
  watch: {
    // eslint-disable-next-line
    selectAllCompaniesModel(check) {
      if (check) this.selectAllCompanies();
      else this.unselectAllcompanies();
    },
  },
  computed: {
    ...mapGetters({
      profile: "getProfile",
      allEvents: "getAllEvents",
      companies: "getCompanies",
      // priorityCompanies: "getPriorityCompanies",
    }),
    checkClass() {
      if (this.showSharingConfirm) {
        return "swal-overlay swal-overlay--show-modal";
      } else {
        return "swal-overlay";
      }
    },
  },
  methods: {
    ...mapActions({
      setProfile: "setProfile",
      setAllEvents: "setAllEvents",
      companiesList: "companiesList",
    }),
    openConfirmModal(group) {
      if (group == "event") this.isEventEdit = true;
      this.showSharingConfirm = true;
    },
    hideConfirm() {
      this.showSharingConfirm = false;
    },
    checkShared(x, isEdit = true) {
      if (!isEdit) {
        return "";
      }
      if (this.profile.other_companies.includes(x)) {
        return "col-lg-6 col-md-6 py-1 shared";
      } else {
        return "col-lg-6 col-md-6 py-1";
      }
    },
    redirect(link) {
      if (!link.startsWith("http://") && !link.startsWith("https://")) {
        link = "http://" + link;
      }
      window.open(link, "_blank");
    },
    eventUrlify(link) {
      var urlRegex = /(https?:\/\/)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi;
      return link.replace(urlRegex, function(url) {
        let checkLinkType =
          url.includes("http") || url.includes("http") ? true : false;
        if (checkLinkType) {
          return (
            '<a href="' +
            url +
            '" target="_blank" style="text-decoration:none;color:#006C6B">' +
            "詳細はこちら" +
            "</a>"
          );
        } else {
          return (
            '<a href="https://' +
            url +
            '" target="_blank" style="text-decoration:none;color:#006C6B">' +
            "詳細はこちら" +
            "</a>"
          );
        }
      });
    },
    async confirmSave() {
      let res = await swal({
        title: "入力情報を更新しますか？",
        text: `更新すると、最終更新日とともに登録先企業への表示が変更されます。\n また、履歴書や職務経歴書をアップロードまたは更新した場合、登録先企業全てに同じ内容が公開されます。`,
        className: "custom-swal",
        closeOnClickOutside: false,
        buttons: {
          cancel: "キャンセル",
          ok: {
            text: "更新する",
            value: true,
            visible: true,
            closeModal: false,
          },
        },
      });
      return res;
    },
    saveSharing(url) {
      this.save(
        {
          other_companies: this.profile.other_companies,
        },
        "sharing"
      );
      this.showSharingConfirm = false;
      this.$refs.profileSharingModal.hide();
    },
    async save(data, url) {
      const check = await this.$validator.validateAll(url);
      if (check) {
        try {
          await this.$auth.getToken();
          await this.axios({
            method: "post",
            data,
            url: Api.url(Api.endpoints[url]),
          });
          if (url === "sharing") {
            //this.agreementcheck = false;
            this.isSharingEdit = true;
            let content = document.createElement("span");
            content.innerHTML = `<p style="font-weight:bold">登録企業を更新しました。</p>`;
            await swal({
              title: "",
              content: content,
              className: "custom-swal4",
              icon: logo,
              buttons: {
                ok: "OK",
              },
            });
            // swal("", "登録企業を更新しました。", "success");
          }
          this.clearErrors();
          return true;
        } catch (error) {
          if (error && error.response && error.response.status === 422) {
            this.server_errors = error.response.data;
          } else if (
            (error.response && error.response.status === 503) ||
            (error.response && error.response.status === 401)
          ) {
            this.$router.push({ name: "Logout" });
          } else {
            swal("", "Something Went Wrong", "error");
          }
          return false;
        } finally {
          swal.close();
        }
      } else {
        swal.close();
      }
    },
    clearErrors() {
      // clear errors
      this.errors.clear();
      this.server_errors = {};
    },
    toggleEdit(group) {
      this.isSharingEdit = false;
      this.$refs.profileSharingModal.show();
      this.tempSharingData.other_companies = this.profile.other_companies;
    },
    cancel() {
        console.log('cancelled');
        this.isSharingEdit = true;
        this.$refs.profileSharingModal.hide();
        this.profile.other_companies = this.tempSharingData.other_companies;
        this.clearErrors();
    },
    selectAllCompanies() {
      this.profile.other_companies = this.data.companies.map(
        (company) => company._id
      );
    },
    unselectAllcompanies() {
      this.profile.other_companies = [];
    },
    scrollToTop() {
      const element = document.getElementsByClassName("main-wrapper")[0];
      if (element) {
        element.scrollIntoView();
      }
    },
    urlify(description) {
      var urlRegex = /(https?:\/\/)?[\w\-~]+(\.[\w\-~]+)+(\/[\w\-~@:%]*)*(#[\w\-]*)?(\?[^\s]*)?/gi;
      return description.replace(urlRegex, function(url) {
        let checkLinkType =
          url.includes("http") || url.includes("http") ? true : false;
        if (checkLinkType)
          return '<a href="' + url + '" target="_blank">' + url + "</a>";
        else
          return (
            '<a href="https://' + url + '" target="_blank">' + url + "</a>"
          );
      });
    },
    async checkMaintenaceMsg() {
      try {
        const response = await this.axios({
          method: "get",
          url: Api.url(Api.endpoints.SITE_INFO),
        });

        if (response.data) {
          const resData = response.data;
          if (resData.data.show_msg == true) {
            this.show_msg = resData.data.show_msg;
            this.maintenance_msg = resData.data.maintenance_msg;
          }
        } else {
          this.show_msg = false;
          this.show_msg = "";
        }
      } catch (error) {
        this.show_msg = false;
        this.maintenance_msg = "";
      }
    },
  },
  async mounted() {
    this.checkMaintenaceMsg();
  },
  async created() {
    this.scrollToTop();
    // console.log(await this.$auth.isAuthenticated());
    Object.keys(this.profile).length === 0 && (await this.setProfile());
    // await this.setProfile();
    await this.setAllEvents();
    // console.log(this.profile.events);
    // await this.loadPriorityCompanies();

    this.companies && !this.companies.length && (await this.companiesList());
    this.data = { companies: this.companies };
    this.$nextTick(()=>{
      if(this.$route.query.openCompanyShare === 'true'){
        this.toggleEdit('sharing')
      } 
    })
  },
};
</script>
<style scoped>

.btn-container {
  float: right;
}

.companies .form-check-label.selected-company {
  text-decoration: underline;
  font-weight: 600;
}

.companies .form-check-label {
  color: #6C757D;
}

/* Checkboxes are disabled on this read-only list; Bootstrap dims them to .5 opacity */
.companies .form-check-input:disabled,
.companies .form-check-input:disabled ~ .form-check-label,
.companies .form-check-input[disabled] ~ .form-check-label {
  opacity: 1;
}

/* BS5 sets appearance:none, so accent-color is ignored — style both states explicitly */
.companies .form-check-input {
  width: 20px;
  height: 20px;
  background-color: #F8F8F8;
  border: 1px solid #6C757D; /* match .form-check-label text colour */
  border-radius: 4px;
}

.companies .form-check-input:checked {
  background-color: #4F46E5;
  border-color: #4F46E5;
}

.event-modal-title {
  margin-top: 60px;
  text-align: center;
  font-weight: 600;
  font-size: 18px;
}
.notice-header-text {
  font-size: 20px;
  text-align: center;
  font-weight: 700;
  color: #ff0000;
}

.notice-list {
  font-weight: bold;
  font-size: 13px;
  padding-left: 20px;
  margin-left: 0;
  /* list-style-type: none; */
}


.responsive-container {
  width: 100%;
  /* max-width: 1140px; */
  margin-left: auto;
  margin-right: auto;
}
.modal-header {
  padding-left: 35px;
  padding-right: 35px;
  justify-content: space-between;
}
.modal-header .close {
  padding: 0px;
  margin: 0px;
}
>>>.modal-footer {
  justify-content: center;
}
.rg-title {
  font-size: 24px;
  font-weight: 700 !important;
}

.select_all_mobile {
  display: none;
}
.swal-footer {
  text-align: center !important;
}

/* .shared {
  background: #006c6b;
  color: #ffff;
}
.shared.card-body {
  color: black;
} */

.button-container {
  display: flex;
  justify-content: center;
}

@media (max-width: 768px) {
  .responsive-container {
    width: 100%;
    max-width: 100%;
    margin-right: auto;
    margin-left: auto;
  }

  .companies-container {
    max-height: 55vh !important;
  }

  .notice-header-text {
    font-size: 20px;
  }

  .notice-list {
    font-weight: bold;
    font-size: 11px;
    padding-left: 20px;
    margin-left: 0;
    /* list-style-type: none; */
  }
  .swal-modal .swal-content {
    padding: 0 20px !important;
  }

  .profile-info-block .edit-block {
    right: 32px !important;
    top: 40px !important;
  }

  .rg-title {
    margin-left: 15px;
    font-size: 16px;
    font-weight: 700;
    padding-top:20px;
  }
 
}

@media (max-width: 530px) {
  .main-area {
    box-shadow: none;
  }
}

.flex-basis-100 {
  flex-basis: 100%;
}

.disable-btn {
  color: gray;
}

.msg-area-profile {
  padding: 15px 15px 30px 15px;
  position: relative;
  display: table;
  margin: 0 auto;
  margin-bottom: 10px;
  border-radius: 0px;
  border: 1px solid #cc0000;
  color: #cc0000;
}
.delete-btn {
  margin-left: 10px;
  color: #fff !important;
  line-height: 24px;
}

@media (max-width: 768px) {

  .editBtn {
    padding-top: 3px !important;
    padding-left: 10px !important;
    padding-right: 10px !important;
    width: 100px !important;
    height: 40px !important;
  }
}

.font-18 {
  font-size: 18px !important;
}

.font-12 {
  font-size: 12px !important;
}


>>> .sharingTitle {
  margin-top: 5px;
  color: black;
  font-weight: 600;
  margin-left:20px;
}

>>> .custom-checkbox {
  width: 20px;
  height: 20px;
  accent-color: #4F46E5;
}

>>> .custom-modal-footer > button {
  min-width: 150px;
}

@media (max-width: 767px) {
  .stickyFooter > div,
  >>> .custom-modal-footer {
    flex-direction: column !important;
  }

  .stickyFooter > div > button:nth-child(1),
  >>> .custom-modal-footer > button:nth-child(1) {
    margin-bottom: 0.5rem !important;
  }

  .editBtn.share {
    width: 20% !important;
  }

}

@media (min-width: 768px) {
  >>> .modal-lg,
  >>> .modal-xl {
    max-width: 800px !important;
  }
}

@media (min-width: 1200px) {
  >>> .modal-xl {
    max-width: 1140px !important;
  }
}

.profile-detail-block h2 {
  font-weight: 600;
  font-size: 24px;
  margin-bottom: 30px;
}

@media (max-width: 550px) {
  >>> .sharingTitle {
    font-size: 18px;
    font-weight: 700;
    margin-left: 0px;
  }

  .profile-detail-block h2 {
    font-weight: 700;
    font-size: 16px;
    margin-bottom: 15px;
  }
}
</style>
